'use client';

import { Crumb } from '@/components/breadcrumbs';
import client from '@/tina/__generated__/client';
import { useTina } from 'tinacms/dist/react';
import PageServer from './pageServer';
import { GlobalsQuery, HomePageQuery, PageByBreadcrumbsQuery } from '../lib/tinaQueries';
export type ArticleQuery = Awaited<ReturnType<typeof client.queries.postConnection>>;
export interface PageProps {
  page: HomePageQuery | PageByBreadcrumbsQuery;
  articles?: ArticleQuery;
  globals: GlobalsQuery;
  breadcrumbs?: Crumb[];
}
export default function PageClient({
  page,
  articles,
  breadcrumbs,
  globals
}: PageProps) {
  const pageClient = useTina({
    query: page.query,
    variables: page.variables,
    data: page.data
  });
  const globalsClient = useTina({
    query: globals.query,
    variables: globals.variables,
    data: globals.data
  });
  return <PageServer articleQuery={articles} isClient={pageClient.isClient} breadcrumbs={breadcrumbs} globalsData={globalsClient.data} pageData={pageClient.data} />;
}